import React from 'react';
import { config } from 'utils/config';
import { i18n } from 'utils/i18n';
import { WINDOW_OBJECT_KEYS } from 'constants';

const RentingAtLocation = () => (
  <div className='help-suggestion'>
    <span className='help-suggestion__title'>{i18n('help_suggestion_title')}</span>
    <a
      className='help-suggestion__link link--arrow'
      target='_blank'
      rel='noopener noreferrer'
      href={config.getRedirectUrl(WINDOW_OBJECT_KEYS.FAQ_PAGE_URL)}
    >
      {i18n('view_faqs')}
    </a>
  </div>
);

export default RentingAtLocation;
